"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var BodyRow_1 = require("./BodyRow");
var BodySection = /** @class */ (function (_super) {
    tslib_1.__extends(BodySection, _super);
    function BodySection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.measuredColumnWidths = {};
        _this.handleReportCellWidthFn = function (columnKey, width) {
            if (_this.props.measureColumnWidths && _this.props.measuredColumnWidths[columnKey] === undefined) {
                _this.measuredColumnWidths[columnKey] = Math.max(width, _this.measuredColumnWidths[columnKey] || 0);
            }
        };
        return _this;
    }
    BodySection.prototype.componentWillMount = function () {
        this.measuredColumnWidths = {};
    };
    BodySection.prototype.componentDidMount = function () {
        this.reportMeasuredColumnWidths();
    };
    BodySection.prototype.componentDidUpdate = function () {
        this.reportMeasuredColumnWidths();
    };
    BodySection.prototype.reportMeasuredColumnWidths = function () {
        if (this.props.measureColumnWidths && Object.keys(this.measuredColumnWidths).length > 0) {
            var measuredColumnWidths = tslib_1.__assign({}, this.measuredColumnWidths);
            this.measuredColumnWidths = {};
            this.props.measureColumnWidths(measuredColumnWidths);
        }
    };
    BodySection.prototype.isRowSelected = function (row, rowIdx) {
        if (!row || !this.props.selectionModel) {
            return false;
        }
        return this.props.selectionModel.isSelected({ colIdx: -1, rowIdx: rowIdx, rowKey: row.key });
    };
    BodySection.prototype.render = function () {
        // tslint:disable-next-line:no-any
        var rowElements = [];
        for (var i = this.props.rowStartIdx; i <= this.props.rowEndIdx; i++) {
            var row = this.props.rows[i];
            var isRowSelected = this.isRowSelected(row, i);
            rowElements.push(BodyRow_1.BodyRow.element({
                key: i,
                row: row,
                rowIdx: i,
                colStartIdx: this.props.colStartIdx,
                colEndIdx: this.props.colEndIdx,
                cols: this.props.cols,
                columnWidths: this.props.columnWidths,
                onCellClick: this.props.onCellClick,
                onCellDoubleClick: this.props.onCellDoubleClick,
                onCellContextMenu: this.props.onCellContextMenu,
                onRowHeaderCellClick: this.props.onRowHeaderCellClick,
                isSelected: isRowSelected,
                selectionModel: this.props.selectionModel,
                selectionTimestamp: this.props.selectionTimestamp,
                showRowBanding: this.props.showRowBanding,
                showHorizontalGridLines: this.props.showHorizontalGridLines,
                showVerticalGridLines: this.props.showVerticalGridLines,
                leftMargin: this.props.leftMargin,
                measuredColumnWidths: this.props.measuredColumnWidths,
                reportWidthFn: this.handleReportCellWidthFn,
                rowOuterHeight: this.props.rowOuterHeight
            }));
        }
        return (React.createElement("div", { role: 'rowgroup', className: 'tb-react-dg-bsection' }, rowElements));
    };
    BodySection.displayName = 'DataGridBodySection';
    BodySection.element = React.createFactory(BodySection);
    return BodySection;
}(React.PureComponent));
exports.BodySection = BodySection;
//# sourceMappingURL=BodySection.js.map